module.exports = "<loading *ngIf=\"loading\"></loading>\n\n<app-not-found *ngIf=\"error && !loading\" [message]=\"message\"></app-not-found>\n\n<div *ngIf=\"!error && !loading\" class=\"wrapper\">\n\n  <div class=\"main\">\n\n    <div class=\"cover\">\n      <channel-cover></channel-cover>\n    </div>\n\n    <div class=\"data\">\n      <channel-data></channel-data>\n    </div>\n\n  </div>\n\n</div>\n\n<app-footer *ngIf=\"!error\"></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/channel/channel.component.html
// module id = ./src/app/channel/channel.component.html
// module chunks = main